/**
 * 使用常量替代 Mutation 事件类型，大写，下划线分割的形式
 */

// 往返标记
export const SET_WFFLAG = 'SET_WFFLAG'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js